/* eslint-disable */
const spacename = 'record-enterprise';
const CHANGE_TABLE_DATA = `${spacename}change_table_data`;
export { CHANGE_TABLE_DATA };
